<template>
  <div class="flex column between container">
    <div class="flex between align-center b4 p8">
      <div class="flex align-center bold">
        <i class="fas fa-shopping-cart r8"></i>
        Shopping Cart
      </div>
      <i
        v-if="$route.name !== 'cart' && $route.name !== 'cart-order'"
        class="fas fa-times"
        @click="$set($store.state.show, 'cart', false)"
      ></i>
      <router-link
        v-else
        to="/"
        class="fas fa-times"
        style="text-decoration: none; color: inherit;"
      ></router-link>
    </div>
    <div
      v-if="
        (($store.state.user && $store.state.user[$store.state.auth.uid] && $store.state.user[$store.state.auth.uid].cart &&
          Object.keys($store.state.user[$store.state.auth.uid].cart).length >
            0) ||
          ($store.state.anon && $store.state.anon.cart &&
            Object.keys($store.state.anon.cart).length > 0)) &&
        !stage
      "
      class="p8 container m8"
    >
      <div class="flex between align-center xs-font">
        <b style="width: 40%; text-align: center" class="">Item</b>
        <b style="width: 20%; text-align: center" class="">Qty</b>
        <b style="width: 20%; text-align: center" class="">Cost</b>
        <b style="width: 20%; text-align: center" class="">Total</b>
      </div>
      <div
        class="column xs-font flexw"
        style="
          overflow: scroll;
          max-height: 100%;
          -webkit-overflow-scrolling: touch;
        "
      >
        <template v-if="items && Object.keys(items).length > 0">
          <div
            class="flex column b16"
            :key="orderKey"
            v-for="(order, orderKey) in items"
          >
          <div class="flex md-font between align-center flexy">
            <router-link
              :to="`/i/${order.type}/${order.id}`"
              style="width: 40%"
              >{{ order.title || $store.state.ref.title[order.id] || order.id }}</router-link
            >
            <span class="center sm-font" style="width: 20%; text-align: center">
              <i
                @click="
                  order.qty > 0
                    ? ($set(
                        $store.state.users[$store.state.auth.uid].cart[
                          orderKey
                        ],
                        3,
                        order.qty - 1
                      ),
                      $store.state.auth.uid ? updateUser() : null)
                    : null
                "
                class="fas fa-arrow-down fa-xs p4"
              ></i>
              <span class="fa-xs">{{ order.qty }}</span>
              <i
                @click="
                  $set(
                    $store.state.users[$store.state.auth.uid].cart[orderKey],
                    3,
                    order.qty + 1
                  );
                  $store.state.auth.uid ? updateUser() : null;
                "
                class="fas fa-arrow-up fa-xs p4"
              ></i>
            </span>
            <span
              class="flex center xs-font column align-center"
              style="width: 20%; text-align: center"
            >
              <div>
                <i
                  class="fa-xs fas r4"
                  :class="`fa-${
                    order.obj.currency === 'USD'
                      ? 'dollar-sign'
                      : order.obj.currency === 'GBP'
                      ? 'pound-sign'
                      : ''
                  }`"
                ></i
                >{{ order.obj.cost }}
              </div>
              <div
                v-if="order.obj.selectedVariations && Object.keys(order.obj.selectedVariations).length > 0"
                class="flex wrap align-center xs-font r4"
                style="font-size: 0.7em;"
              >
                <span
                  v-for="(variation, varType) in order.obj.selectedVariations"
                  :key="varType"
                  class="r4"
                >
                  {{varType}}: {{variation.name || variation}}
                </span>
              </div>
            </span>
            <span style="width: 20%; text-align: center" class="center"
              ><i
                class="fa-xs fas r4"
                :class="`fa-${
                  order.obj.currency === 'USD'
                    ? 'dollar-sign'
                    : order.obj.currency === 'GBP'
                    ? 'pound-sign'
                    : ''
                }`"
              ></i
              >{{
                Number(order.obj.cost * order.qty).toFixed(2)
              }}</span
            >
          </div>
          <div class="flex align-center between xs-font flexy p4">
            <user :userid="order.seller"></user>
            <code
              @click="
                delete $store.state.users[$store.state.auth.uid].cart[orderKey];
                $store.state.auth.uid ? updateUser() : delete items[orderKey];
              "
              class="warn-text"
            >
              <i class="far fa-trash-alt"></i> Remove
            </code>
          </div>
          </div>
        </template>
        <!-- Shipping and handling grouped by seller -->
        <div v-if="sellerShipping && Object.keys(sellerShipping).length > 0" class="flex column b16 p8 border-top">
          <div class="xs-font b8"><b>Shipping & Handling:</b></div>
          <div
            v-for="(shipping, sellerId) in sellerShipping"
            :key="sellerId"
            class="flex between align-center xs-font p4"
          >
            <user :userid="sellerId"></user>
            <span class="r4">
              <i
                class="fa-xs fas r4"
                :class="`fa-${
                  currency === 'USD'
                    ? 'dollar-sign'
                    : currency === 'GBP'
                    ? 'pound-sign'
                    : ''
                }`"
              ></i>
              {{ shipping }} s&h
            </span>
          </div>
        </div>
        <!-- $set($store.state.users[$store.state.auth.uid].cart[orderKey], order.ts, null) -->
      </div>
    </div>
    <div
      v-if="
        (($store.state.user && $store.state.user[$store.state.auth.uid] && $store.state.user[$store.state.auth.uid].cart &&
          Object.keys($store.state.user[$store.state.auth.uid].cart).length >
            0) ||
          ($store.state.anon && $store.state.anon.cart &&
            Object.keys($store.state.anon.cart).length > 0)) &&
        !stage
      "
      style="align-items: center"
      class="flex around p8"
    >
      <b class="flexx flex align-center"
        ><span class="r8 md-font">Total</span>
        <i
          v-if="currency"
          class="fas"
          :class="`fa-${
            currency.toLowerCase() === 'usd'
              ? 'dollar-sign'
              : currency.toLowerCase() === 'gbp'
              ? 'pound-sign'
              : ''
          }`"
        ></i
        >{{ total }}</b
      >
      <button
        @click="stage = 'checkout'"
        class="flexx md-font success p16 box-glow"
        type="button"
      >
        <i class="fas fa-shopping-cart r8"></i> CHECKOUT
      </button>
    </div>
    <div
      class="flex between column md-font"
      style="height:100%"
      v-else-if="
        (($store.state.user && $store.state.user[$store.state.auth.uid] && $store.state.user[$store.state.auth.uid].cart) ||
          ($store.state.anon && $store.state.anon.cart)) &&
        stage === 'checkout'
      "
    >
      <div style="align-items: center" class="flex between p8">
        <i class="fas fa-chevron-left" @click="stage = false"></i>
        <span class="flex center r8">
          <span class="r8">Total</span>
          <i
            v-if="currency"
            class="fas r4"
            :class="`fa-${
              currency.toLowerCase() === 'usd'
                ? 'dollar-sign'
                : currency.toLowerCase() === 'gbp'
                ? 'pound-sign'
                : ''
            }`"
          ></i
          >{{ total }}</span>
      </div>
      <div
        style="
          overflow: scroll;
          -webkit-overflow-scrolling: touch;
          height: 100%;
          width: 100%;
        "
        class="flexw"
      >
        <!-- Commented out credit card form fields - keeping in code but hidden -->
        <!-- Credit card fields: number, cvc, month, year are now commented out in form config -->
        <div :class="{ 'hide-submit-button': isCreditSelected }">
          <iform :form-model="filteredCheckoutForm"></iform>
        </div>
        <!-- Replace PURCHASE button with "Pay with Stripe" button when Credit payment type is selected -->
        <div 
          v-if="isCreditSelected" 
          class="p8" 
          style="border-top: 1px solid rgba(0,0,0,0.1);"
        >
          <button
            @click="goToStripeCheckout"
            :disabled="!isTermsAgreed"
            class="flexx md-font success p16 box-glow"
            :class="{ 'disabled': !isTermsAgreed }"
            type="button"
            style="width: 100%;"
          >
            <i class="fab fa-cc-stripe r8"></i> Pay with Stripe
          </button>
        </div>
      </div>
    </div>
    <div v-else>
      <code>No items in cart.</code>
    </div>
  </div>
</template>

<script>
export default {
  name: "cart",

  computed: {
    sellerShipping() {
      const shippingBySeller = {};
      Object.keys(this.items).forEach((itemKey) => {
        const item = this.items[itemKey];
        const sellerId = item.seller;
        const shipping = typeof item.obj["shipping and handling"] === "number"
          ? item.obj["shipping and handling"]
          : 0;
        
        if (shipping > 0) {
          if (!shippingBySeller[sellerId] || shipping > shippingBySeller[sellerId]) {
            shippingBySeller[sellerId] = shipping;
          }
        }
      });
      return shippingBySeller;
    },
    total() {
      var newTotal = 0;
      Object.keys(this.items).forEach((item) => {
        newTotal = newTotal + this.items[item].qty * this.items[item].obj.cost;
      });
      // Add shipping once per seller (highest value)
      Object.keys(this.sellerShipping).forEach((sellerId) => {
        newTotal = newTotal + this.sellerShipping[sellerId];
      });
      return Number(newTotal).toFixed(2);
    },
    filteredCheckoutForm() {
      // Comment out credit card fields but keep them in code
      const form = this.$store.state.models.iform.checkout;
      if (!form || !form.forms) return form;
      
      // Get allowed payment types from admin config
      const allowedPaymentTypes = this.$store.state.app.payments?.["payment-types"] || [];
      
      const filteredForm = JSON.parse(JSON.stringify(form)); // Deep clone
      filteredForm.forms = filteredForm.forms.map(formSection => {
        if (formSection.name === 'Payment') {
          formSection.inputs = formSection.inputs.map(input => {
            // Filter payment type options based on admin config
            if (input.label === 'payment-type' && input.options) {
              if (allowedPaymentTypes.length > 0) {
                // Filter options to only include allowed payment types
                input.options = input.options.filter(option => {
                  const optionName = option.name || option;
                  return allowedPaymentTypes.includes(optionName);
                });
              }
              return input;
            }
            
            // Filter out credit card fields that are conditional on Credit payment type
            if (['number', 'cvc', 'month', 'year'].includes(input.label) && 
                input.if && input.if[1] === 'Credit') {
              // Commented out - keeping in code but not displaying
              return null;
            }
            return input;
          }).filter(Boolean);
        }
        return formSection;
      });
      return filteredForm;
    },
    isCreditSelected() {
      // Check if Credit payment type is selected
      // Form name is "Checkout" (capital C), not "checkout"
      const formData = this.$store.state.models.retModel?.Checkout?.model || {};
      return formData.Payment && formData.Payment['payment-type'] === 'Credit';
    },
    isTermsAgreed() {
      // Check if "Agree to terms" checkbox is checked
      const formData = this.$store.state.models.retModel?.Checkout?.model || {};
      return formData.Payment && formData.Payment['Agree to terms'] === true;
    },
  },
  props: {
    orderId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      currency: "",
      msg: "Underground Music Events",
      showError: false,
      items: {},
      stage: false,
    };
  },
  methods: {
    async getItems() {
      // If orderId is provided, load order data instead of cart
      const orderId = this.orderId || (this.$route && this.$route.params && this.$route.params.orderId);
      if (orderId) {
        try {
          // Load order data
          await this.$store.dispatch('query', {
            type: 'orders',
            id: orderId
          });
          
          const order = this.$store.state.ref.orders && this.$store.state.ref.orders[orderId];
          if (order && order.items) {
            // Populate cart with order items
            const cart = {};
            order.items.forEach((item, index) => {
              const cartKey = `${item.type}_${item.iitemid}_${index}`;
              cart[cartKey] = [
                item.type,
                item.iitemid,
                item.purchase,
                item.qty,
                item.seller,
                item.itemTitle
              ];
            });
            
            // Set cart in store
            if (this.$store.state.user && this.$store.state.user[this.$store.state.auth.uid]) {
              this.$set(this.$store.state.user[this.$store.state.auth.uid], 'cart', cart);
            } else if (this.$store.state.anon) {
              this.$set(this.$store.state.anon, 'cart', cart);
            }
            
            // Store the existing orderId so checkout knows to update instead of create
            this.$store.state.pendingOrderUpdate = {
              orderId: orderId,
              existingOrder: order
            };
          }
        } catch (error) {
          console.error('Error loading order:', error);
        }
      }
      
      // Initialize anon cart if needed
      if (!this.$store.state.anon) {
        this.$set(this.$store.state, 'anon', {});
      }
      
      // Get cart from localStorage if user isn't logged in and cart exists in localStorage
      if (!this.$store.state.user || !this.$store.state.user[this.$store.state.auth.uid]) {
        this.$store.state.anon.cart = window.localStorage.getItem("cart")
          ? JSON.parse(window.localStorage.getItem("cart"))
          : {};
      } else {
        // Initialize user cart if needed
        if (!this.$store.state.user[this.$store.state.auth.uid].cart) {
          this.$set(this.$store.state.user[this.$store.state.auth.uid], 'cart', {});
        }
      }
      
      // Set var rawItems to users cart if they're logged in, anon cart if they're not
      var rawItems = (this.$store.state.user && this.$store.state.user[this.$store.state.auth.uid])
        ? this.$store.state.user[this.$store.state.auth.uid].cart
        : (this.$store.state.anon ? this.$store.state.anon.cart : {});

      var rawOrders = {}; // Create empty object to collect each item
      Object.keys(rawItems).forEach((item) => {
        var weeEntry = rawItems[item];
        
        // Handle both array format (new) and object format (old)
        if (Array.isArray(weeEntry)) {
          // New array format: [type, id, purchases, qty, user, title]
          if (!rawOrders[item]) {
            rawOrders[item] = {
              type: weeEntry[0],
              id: weeEntry[1],
              obj: weeEntry[2],
              qty: weeEntry[3],
              seller: weeEntry[4],
              title: weeEntry[5],
              ts: Date.now(),
            };
          } else {
            if (
              rawOrders[item].obj.cost +
                (typeof rawOrders[item].obj["shipping and handling"] === "number"
                  ? rawOrders[item].obj["shipping and handling"]
                  : 0) ===
              weeEntry[2].cost +
                (typeof weeEntry[2]["shipping and handling"] === "number"
                  ? weeEntry[2]["shipping and handling"]
                  : 0)
            ) {
              rawOrders[item].qty = rawOrders[item].qty + weeEntry[3];
            } else {
              rawOrders[item + "-variant"] = {
                type: weeEntry[0],
                id: weeEntry[1],
                obj: weeEntry[2],
                qty: weeEntry[3],
                seller: weeEntry[4],
                title: weeEntry[5],
                ts: Date.now(),
              };
            }
          }
        } else if (typeof weeEntry === 'object' && weeEntry !== null) {
          // Old object format: { timestamp: [type, id, purchases, qty, user, title] }
          Object.keys(weeEntry).forEach(timestamp => {
            var entry = weeEntry[timestamp];
            if (Array.isArray(entry)) {
              if (!rawOrders[item]) {
                rawOrders[item] = {
                  type: entry[0],
                  id: entry[1],
                  obj: entry[2],
                  qty: entry[3],
                  seller: entry[4],
                  title: entry[5],
                  ts: parseInt(timestamp),
                };
              } else {
                if (
                  rawOrders[item].obj.cost +
                    (typeof rawOrders[item].obj["shipping and handling"] === "number"
                      ? rawOrders[item].obj["shipping and handling"]
                      : 0) ===
                  entry[2].cost +
                    (typeof entry[2]["shipping and handling"] === "number"
                      ? entry[2]["shipping and handling"]
                      : 0)
                ) {
                  rawOrders[item].qty = rawOrders[item].qty + entry[3];
                } else {
                  rawOrders[item + "-variant-" + timestamp] = {
                    type: entry[0],
                    id: entry[1],
                    obj: entry[2],
                    qty: entry[3],
                    seller: entry[4],
                    title: entry[5],
                    ts: parseInt(timestamp),
                  };
                }
              }
            }
          });
        }
        
        if (rawOrders[item]) {
          this.currency = rawOrders[item].obj.currency;
        }
      });
      this.$store.state.counts.cart = Object.keys(rawOrders).length;
      this.items = rawOrders;
      
      // If no items found but we have an orderId, try to load order data
      if (Object.keys(rawOrders).length === 0 && orderId) {
        // Order loading is handled above, but if it failed, items will be empty
        console.log('No items found for order:', orderId);
      }
    },
    updateUser() {
      var saveObj = {
        type: "user",
        id: this.$store.state.auth.uid,
        // noReload: true,
        data: this.$store.state.users[this.$store.state.auth.uid],
      };
      this.$store.dispatch("update", saveObj).then(() => {
        this.$set(
          this.$store.state.componentKeys,
          "cart",
          this.$store.state.componentKeys.cart + 1
        );
      });
    },
    async goToStripeCheckout() {
      // Create order first, then redirect to Stripe Checkout
      const axios = require('axios');
      // Form name is "Checkout" (capital C), not "checkout"
      const formData = this.$store.state.models.retModel?.Checkout?.model || {};
      
      // Get cart items
      const cart = this.$store.state.user[this.$store.state.auth.uid]?.cart || 
                   this.$store.state.anon?.cart || {};
      
      // Calculate total from cart items
      let orderTotal = 0;
      Object.keys(this.items).forEach((item) => {
        orderTotal = orderTotal + this.items[item].qty * this.items[item].obj.cost;
        orderTotal =
          orderTotal +
          (typeof this.items[item].obj["shipping and handling"] === "number"
            ? this.items[item].obj["shipping and handling"]
            : 0);
      });
      orderTotal = Number(orderTotal).toFixed(2);
      
      // Create order with shipping info and cart
      const orderPayload = {
        data: {
          Shipping: formData.Shipping || {},
          Payment: {
            'payment-type': 'Credit' // Set payment type to Credit
          }
        },
        cart: cart, // Pass cart to order creation
        type: 'order'
      };
      
      try {
        // Create the order
        const orderResult = await this.$store.dispatch('create', orderPayload);
        const orderId = orderResult?.id || orderResult;
        
        console.log('[STRIPE CHECKOUT] Order created:', orderId);
        
        // Use the calculated total from cart items
        const orderTotalNum = Number(orderTotal);
        
        // Get database from state.app.basics.database
        const database = this.$store.state.app?.basics?.database || 'xmbl';
        console.log('[STRIPE CHECKOUT] Using database:', database);
        
        // Call Stripe Checkout
        const cloudurl = this.$store.state.cloudurl || 'https://us-central1-xmba-cloud-api.cloudfunctions.net/';
        
        const checkoutResponse = await axios.post(cloudurl + 'stripecheckout', {
          orderId: orderId,
          amount: orderTotalNum,
          currency: 'usd',
          description: orderId,
          database: database // Pass database so webhook knows which Firestore collection to update
        });
        
        console.log('[STRIPE CHECKOUT] Checkout session created:', checkoutResponse.data);
        
        if (checkoutResponse.data.url) {
          // Redirect to Stripe Checkout
          window.location.href = checkoutResponse.data.url;
        } else {
          throw new Error('No checkout URL received');
        }
      } catch (error) {
        console.error('[STRIPE CHECKOUT] Error:', error);
        this.$store.dispatch('notify', {
          type: 'billing',
          text: 'Failed to create checkout session: ' + (error.response?.data?.error || error.message),
          users: [this.$store.state.auth.uid],
          from: 'Stripe',
          link: '/cart',
          id: 'checkout-error'
        });
      }
    },
  },
  async mounted() {
    await this.getItems();
    // If orderId prop or route param is provided, go directly to checkout stage
    const orderId = this.orderId || (this.$route && this.$route.params && this.$route.params.orderId);
    if (orderId) {
      this.stage = 'checkout';
    }
  },
  watch: {
    "$store.state.user": {
      handler: function (newVal) {
        if (newVal) {
          this.getItems();
        }
      },
      deep: true
    },
    "$store.state.anon": {
      handler: function (newVal) {
        if (newVal && newVal.cart) {
          this.getItems();
        }
      },
      deep: true
    },
    "$route.params.orderId": function (newOrderId) {
      if (newOrderId) {
        this.getItems().then(() => {
          this.stage = 'checkout';
        });
      }
    },
  },
};
</script>
<style scoped>
/* Hide the form's submit button when Credit is selected */
.hide-submit-button >>> .form_footer button[type="submit"] {
  display: none !important;
}

/* Disable button styling */
button.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}
</style>
